<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: 'Layout',
    }
</script>


// WEBPACK FOOTER //
// src/components/Layout.vue